var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1091,
    height: 1020,
    viewBox: "0 0 1091 1020",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_595_3310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1258.5 1108.05C1262.3 1095.94 1261.35 1082.83 1255.84 1071.39L894.001 320.505C887.999 308.05 877.109 298.637 863.918 294.5L412.528 152.96C386.179 144.698 358.121 159.36 349.859 185.71L196.944 673.373C193.143 685.496 194.099 698.612 199.619 710.055L561.871 1461.08C567.875 1473.52 578.761 1482.93 591.946 1487.07L1042.92 1628.48C1069.27 1636.74 1097.32 1622.07 1105.59 1595.73L1258.5 1108.05Z",
    fill: "url(#paint0_linear_595_3310)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_595_3310",
    x: 44.6538,
    y: 0.65625,
    width: 1366.14,
    height: 1780.12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_595_3310"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_595_3310",
    x1: 365.058,
    y1: 137.919,
    x2: 1185.1,
    y2: 1590.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9708CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43CBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.965a459498674b642085d50404238fdb.svg";
export { ForwardRef as ReactComponent };